<div class="productos-container">
    <div class="header-actions">
      <h1>Catálogo de Proveedores</h1>
      <button mat-raised-button color="primary" (click)="abrirDialogoProducto()">
        <mat-icon>add</mat-icon> Nuevo Proveedor
      </button>
    </div>
  <app-table-generic
    [config]="(tableConfig$ | async) || { columns: [] }"
    [data]="(data$ | async) || [] "
    [totalItems]="(totalItems$ | async) || 0"
    [loading]="(loading$ | async) || false"
    [error]="error$ | async"
    (editClick)="onEdit($event)"
    [dialogComponent] = "dialogComponent" 
    (deleteClick)="onDelete($event)">
  </app-table-generic>
  
  </div>